module.exports = __webpack_public_path__ + "img/GAME_BALLOON2.1bae25d1.jpg";